var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "phone-forget"
  }, [_vm.wayType === 'phone' ? _c('div', {
    staticClass: "phone-inner"
  }, [_c('div', {
    staticClass: "return",
    on: {
      "click": function click($event) {
        return _vm.selectWay('phone');
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fonts title"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.forget2'))))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.verificated,
      expression: "!verificated"
    }]
  }, [_c('div', {
    staticClass: "fonts intro"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.phoneResetTip'))))]), _vm._v(" "), _c('verificate-input', {
    attrs: {
      "type": 3,
      "name": _vm.loginName,
      "itc": _vm.itc,
      "country": _vm.country,
      "imgCode": _vm.imgCode
    },
    on: {
      "changeCodeError": _vm.changeCodeErrorHandle,
      "changeCode": _vm.changeCodeHandle,
      "changeImgCodeError": _vm.changeImgCodeErrorHandle,
      "changeImgCodeValue": _vm.changeImgCodeValueHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.codeError
    }
  }), _vm._v(" "), _c('code-input', {
    ref: "imgcodeinput",
    attrs: {
      "reg": "reg",
      "type": "phone",
      "name": _vm.loginName
    },
    on: {
      "changeCode": _vm.changeImgCodeHandle,
      "changeCodeError": _vm.changeImgCodeErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.imgCodeError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fonts send",
    class: {
      has: _vm.code && !_vm.codeError,
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.verificateCode();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.next'))))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verificated,
      expression: "verificated"
    }]
  }, [_c('div', {
    staticClass: "fonts intro"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.newpwTip'))))]), _vm._v(" "), _c('password-input', {
    on: {
      "changePassword": _vm.changePasswordHandle,
      "changePasswordError": _vm.changePasswordErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.passwordError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fonts send",
    class: {
      has: _vm.password && !_vm.passwordError,
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.send();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.confirmreset'))))])], 1), _vm._v(" "), _c('p', {
    staticClass: "fonts inphone",
    on: {
      "click": function click($event) {
        return _vm.selectWay('email');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.emailType'))))])]) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-phone' ? _c('div', {
    staticClass: "mphone-inner"
  }, [_c('div', {
    staticClass: "fonts title mb"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.forget2'))))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.verificated,
      expression: "!verificated"
    }]
  }, [_c('div', {
    staticClass: "fonts intro mb"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.phoneResetTip'))))]), _vm._v(" "), _c('verificate-input', {
    attrs: {
      "type": 3,
      "mb": "mb",
      "name": _vm.loginName,
      "itc": _vm.itc,
      "country": _vm.country,
      "imgCode": _vm.imgCode
    },
    on: {
      "changeCodeError": _vm.changeCodeErrorHandle,
      "changeCode": _vm.changeCodeHandle,
      "changeImgCodeError": _vm.changeImgCodeErrorHandle,
      "changeImgCodeValue": _vm.changeImgCodeValueHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.codeError,
      "mb": "mb"
    }
  }), _vm._v(" "), _c('code-input', {
    ref: "imgcodeinput",
    attrs: {
      "mb": "mb",
      "reg": "reg",
      "type": "phone",
      "name": _vm.loginName
    },
    on: {
      "changeCode": _vm.changeImgCodeHandle,
      "changeCodeError": _vm.changeImgCodeErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "mb": "mb",
      "txt": _vm.imgCodeError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fonts send mb",
    class: {
      has: _vm.code && !_vm.codeError,
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.verificateCode();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.next'))))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.verificated,
      expression: "verificated"
    }]
  }, [_c('div', {
    staticClass: "fonts intro mb"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.newpwTip'))))]), _vm._v(" "), _c('password-input', {
    attrs: {
      "mb": "mb"
    },
    on: {
      "changePassword": _vm.changePasswordHandle,
      "changePasswordError": _vm.changePasswordErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.passwordError,
      "mb": "mb"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fonts send mb",
    class: {
      has: _vm.password && !_vm.passwordError,
      cover: _vm.cover
    },
    on: {
      "click": function click($event) {
        return _vm.send();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.confirmreset'))))])], 1), _vm._v(" "), _c('p', {
    staticClass: "fonts inphone mb",
    on: {
      "click": function click($event) {
        return _vm.selectWay('m-email');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.emailType'))))])]) : _vm._e(), _vm._v(" "), _c('toast-pop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toastState,
      expression: "toastState"
    }],
    attrs: {
      "txt": _vm.txt
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };